<script>
import MetabaseService from "@/services/MetabaseService";

export default {
    props: {
        reference: {}
    },
    data() {
        return {
            loading: true,
            embedLoading: true,
            signed: "",
            tmp: {}
        };
    },
    async created() {
        await this.signEmbed();
        this.resizeIframe();
    },
    mounted() {
        window.addEventListener("resize", this.resizeIframe);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.resizeIframe);
    },
    methods: {
        async signEmbed() {
            try {
                const { data } = await MetabaseService.POST_sign(
                    this.reference
                );
                this.tmp = data.data;
                this.signed = data.data.embed;
            } catch (e) {
                console.log("fe", e);
            }
            this.embedLoading = false;
        },
        resizeIframe() {
            const height = window.innerHeight - 100;
            const iframe = this.$refs.metabaseFrame;
            if (iframe) {
                iframe.style.width = "100%";
                iframe.style.height = `${height}px`;
                iframe.style.overflow = "auto";
            }
        },

        onIframeLoad() {
            this.loading = false;
        }
    }
};
</script>

<template>
    <div>
        <v-loader :loading="loading" v-if="loading" />
        <template v-if="embedLoading === false">
            <iframe
                ref="metabaseFrame"
                @load="onIframeLoad"
                id="metabase-frame"
                :src="signed"
                frameborder="0"
                allowtransparency
            ></iframe>
        </template>
    </div>
</template>

<style lang="scss">
#metabase-frame {
}
</style>
